export default "__VITE_ASSET__rxXCN_SS__"